"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4739],{

/***/ 4739:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ main_ClassGridList; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(7379);
// EXTERNAL MODULE: ./src/components/molecules/class/card/ColumnItem.js
var ColumnItem = __webpack_require__(5999);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./src/components/atoms/icons/Star.js
var Star = __webpack_require__(6694);
// EXTERNAL MODULE: ./src/components/atoms/photos/ClassCover.js
var ClassCover = __webpack_require__(450);
// EXTERNAL MODULE: ./src/components/atoms/photos/Avatar.js
var Avatar = __webpack_require__(3315);
// EXTERNAL MODULE: ./src/cds/styles.ts
var styles = __webpack_require__(3887);
;// CONCATENATED MODULE: ./src/components/molecules/event/badge/Message.js


// styles

function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  width: auto;\n  height: 24px;\n  border-radius: 3px;\n  top: 4px;\n  left: 4px;\n  padding: 4px;\n  font-size: 10px;\n  color: ",
        ";\n  background-color: ",
        ";\n\n  ",
        " {\n    top: 8px;\n    left: 8px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
/**
 * 메세지 배지
 * @param {object} props
 * @param {string} props.children
 */ var MessageBadge = function(param) {
    var children = param.children;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        children: children
    }));
};
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e448ca46-0"
})(_templateObject(), styles/* palette.white */.DG.white, styles/* palette.red060 */.DG.red060, styles/* mediaQuery.medium */.cy.medium);
/* harmony default export */ var Message = (MessageBadge);

;// CONCATENATED MODULE: ./src/components/molecules/event/badge/Close.js


// styles

function Close_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function Close_templateObject() {
    var data = Close_taggedTemplateLiteral([
        "\n  position: absolute;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  border-radius: 8px;\n  top: 0;\n  left: 0;\n  padding: 4px;\n  font-size: 18px;\n  letter-spacing: 0.2rem;\n  color: ",
        ";\n  background-color: ",
        ";\n\n  ",
        " {\n    font-size: 24px;\n  }\n"
    ]);
    Close_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
/**
 * 닫기 배지
 */ var CloseCover = function() {
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Close_Wrapper, {
        children: "CLOSE"
    }));
};
var Close_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-89fa018a-0"
})(Close_templateObject(), styles/* palette.white */.DG.white, styles/* palette.dim.basic */.DG.dim.basic, styles/* mediaQuery.medium */.cy.medium);
/* harmony default export */ var Close = (CloseCover);

;// CONCATENATED MODULE: ./src/components/molecules/event/badge/Ready.js


// styles

function Ready_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function Ready_templateObject() {
    var data = Ready_taggedTemplateLiteral([
        "\n  position: absolute;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  border-radius: 8px;\n  top: 0;\n  left: 0;\n  padding: 4px;\n  font-size: 18px;\n  letter-spacing: 0.2rem;\n  color: ",
        ";\n  background-color: ",
        ";\n\n  & > img {\n    width: 72px;\n    height: 72px;\n  }\n\n  ",
        " {\n    font-size: 20px;\n  }\n"
    ]);
    Ready_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
/**
 * 오픈준비 배지
 */ var ReadyCover = function() {
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Ready_Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
            src: "".concat("https://cdn.classu.co.kr", "/img/class/icon_time_to_deal.png"),
            alt: "타임 특가"
        })
    }));
};
var Ready_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ecd930a0-0"
})(Ready_templateObject(), styles/* palette.white */.DG.white, styles/* palette.dim.basic */.DG.dim.basic, styles/* mediaQuery.medium */.cy.medium);
/* harmony default export */ var Ready = (ReadyCover);

// EXTERNAL MODULE: ./src/hooks/bridge/useCommonBridge.js
var useCommonBridge = __webpack_require__(5397);
// EXTERNAL MODULE: ./src/hooks/common/useWebview.js
var useWebview = __webpack_require__(4639);
// EXTERNAL MODULE: ./src/hooks/common/useStore.ts
var useStore = __webpack_require__(8004);
// EXTERNAL MODULE: ./src/lib/utils/format/number.js
var number = __webpack_require__(4593);
// EXTERNAL MODULE: ./src/lib/utils/format/time.js
var time = __webpack_require__(508);
// EXTERNAL MODULE: ./src/cds/typography.ts
var typography = __webpack_require__(506);
;// CONCATENATED MODULE: ./src/components/molecules/class/card/EventItem.js



// components






// hooks



// utils


// styles


function EventItem_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function EventItem_templateObject() {
    var data = EventItem_taggedTemplateLiteral([
        "\n  background-color: ",
        ";\n  border-radius: 4px;\n"
    ]);
    EventItem_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = EventItem_taggedTemplateLiteral([
        "\n          display: flex;\n          align-items: flex-start;\n          border-bottom: 1px solid ",
        ";\n          padding: 12px 0;\n\n          ",
        " {\n            border-bottom: 1px solid ",
        ";\n          }\n        "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = EventItem_taggedTemplateLiteral([
        "\n          display: block;\n        "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = EventItem_taggedTemplateLiteral([
        "\n  position: relative;\n  cursor: pointer;\n  ",
        ";\n\n  &:active {\n    /* background-color: ",
        "; */\n  }\n\n  ",
        " {\n    display: block;\n    border-bottom: 0;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = EventItem_taggedTemplateLiteral([
        "\n          min-width: 40%;\n          width: 40%;\n          max-width: 40%;\n        "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = EventItem_taggedTemplateLiteral([
        "\n          width: 100%;\n          max-width: 100%;\n        "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = EventItem_taggedTemplateLiteral([
        "\n  position: relative;\n  flex: 1 1 0;\n\n  ",
        ";\n\n  ",
        " {\n    width: 100%;\n    max-width: 100%;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = EventItem_taggedTemplateLiteral([
        "\n          & > div:first-of-type {\n            display: none;\n          }\n\n          & > div:last-of-type {\n            margin: 0 0 0 12px;\n          }\n        "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = EventItem_taggedTemplateLiteral([
        "\n          margin-top: 8px;\n\n          & > div:first-of-type {\n            display: block;\n          }\n\n          & > div:last-of-type {\n            margin: 0;\n          }\n        "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = EventItem_taggedTemplateLiteral([
        "\n  flex: 1 1 0%;\n  display: flex;\n  align-items: flex-start;\n  opacity: ",
        ";\n\n  & > div:first-of-type {\n    display: none;\n    flex: 0 auto;\n    width: 32px;\n    padding: 4px 0 0;\n    margin: 0 12px 0 0;\n  }\n\n  & > div:last-of-type {\n    overflow: hidden;\n    flex: 0 auto;\n    margin: 0 0 0 12px;\n  }\n\n  ",
        ";\n\n  ",
        " {\n    margin-top: 8px;\n\n    & > div:first-of-type {\n      display: block;\n    }\n\n    & > div:last-of-type {\n      margin: 0;\n    }\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = EventItem_taggedTemplateLiteral([
        "\n  flex: 0 auto;\n  width: 32px;\n  height: 32px;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = EventItem_taggedTemplateLiteral([
        "\n  display: block;\n  display: -webkit-box;\n  position: relative;\n  padding: 0;\n  margin-bottom: 4px;\n  ",
        "\n  color: ",
        ";\n  white-space: break-spaces;\n  word-break: keep-all;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 2;\n\n  &::after {\n    content: '...';\n    text-align: right;\n    bottom: 0;\n    right: 0;\n    width: 25%;\n    display: block;\n    position: absolute;\n    height: calc(1em * 1.2);\n    background: linear-gradient(to right, rgba(255, 255, 255, 0), rgba(255, 255, 255, 1) 75%);\n  }\n\n  @supports (-webkit-line-clamp: 2) {\n    &::after {\n      display: none;\n    }\n  }\n\n  &:empty {\n    ",
        ";\n    height: 20px;\n  }\n\n  ",
        " {\n    font-size: 15px;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = EventItem_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  margin-bottom: 4px;\n  ",
        "\n  color: ",
        ";\n\n  ",
        " {\n    ",
        "\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = EventItem_taggedTemplateLiteral([
        "\n  overflow: hidden;\n  flex: 0 auto;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  color: ",
        ";\n\n  &:empty {\n    ",
        ";\n    width: 150px;\n    height: 22px;\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = EventItem_taggedTemplateLiteral([
        "\n  flex: 0 0 auto;\n\n  &::before {\n    content: '\xb7';\n    margin: 0 4px;\n  }\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = EventItem_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  margin-bottom: 8px;\n\n  & > i {\n    margin-left: 8px;\n    font-size: 14px;\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = EventItem_taggedTemplateLiteral([
        "\n  flex: 0 auto;\n  margin-right: 6px;\n  ",
        "\n  color: ",
        ";\n  font-weight: 700;\n\n  ",
        " {\n    font-size: 16px;\n    letter-spacing: 0;\n  }\n\n  &:empty {\n    ",
        ";\n    width: 28px;\n    height: 22px;\n  }\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = EventItem_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: baseline;\n  flex: 0 auto;\n  ",
        "\n  color: ",
        ";\n\n  & span {\n    margin-right: 4px;\n    font-size: 14px;\n  }\n\n  &:empty {\n    ",
        ";\n    width: 76px;\n    height: 22px;\n  }\n\n  ",
        " {\n    font-size: 16px;\n    letter-spacing: 0;\n  }\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = EventItem_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  ",
        "\n  font-size: 11px;\n  color: ",
        ";\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n\n  ",
        " {\n    font-size: 13px;\n  }\n\n  & span {\n    display: flex;\n    align-items: center;\n    flex: 0 auto;\n\n    svg {\n      margin-right: 2px;\n    }\n  }\n\n  & span ~ span::before {\n    display: inline-block;\n    content: '';\n    width: 1px;\n    margin: 0 4px;\n    height: 8px;\n    background: ",
        ";\n  }\n\n  &:empty {\n    ",
        ";\n    width: 110px;\n    height: 18px;\n  }\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = EventItem_taggedTemplateLiteral([
        "\n  display: inline-block;\n  padding: 0 4px 1px;\n  margin-top: 8px;\n  border: 1px solid ",
        ";\n  color: ",
        ";\n  border-radius: 2px;\n  font-size: 12px;\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
/**
 * 클래스 아이템 event 타입 카드
 * @param {object} props
 * @param {import('types/slices/event').EventClass} props.data 클래스 정보
 */ var EventItem = function(param) {
    var data = param.data;
    var router = (0,next_router.useRouter)();
    var asPath = router.asPath;
    var userInfo = (0,useStore/* useSelector */.v)(function(state) {
        return state.user.info;
    });
    var eventInfo = (0,useStore/* useSelector */.v)(function(state) {
        return state.event.plan.info;
    });
    var IS_ROWITEM = eventInfo.id !== 51;
    var IS_EARLYBIRD_EVENT = eventInfo.id === 1;
    var IS_MONTHLY_EVENT = asPath.indexOf('month') > -1;
    var ref = (0,useCommonBridge/* default */.Z)(), goToClassDetail = ref.goToClassDetail, goToProfile = ref.goToProfile;
    var isWebview = (0,useWebview/* default */.Z)().isWebview;
    // 타임딜의 경우, 해당 클래스의 close_date 값이 없어, 이벤트가 끝나는 시간 기준으로 한다.
    var CLOSE_TIEM_DEAL = new Date((0,time/* iosTimeFormat */.jH)(eventInfo.close_date)) < (0,time/* getKoreaDate */.jw)();
    var getDateDiff = function(start, end) {
        return ((start.getTime() - end.getTime()) / (1000 * 60 * 60 * 24)).toFixed(0) * 1;
    };
    var setMidnight = function(date) {
        return new Date(new Date(date).setHours(0, 0, 0, 0) + 1000 * 60 * 60 * 24 * 1);
    };
    var onClickClass = function(e) {
        if (!IS_MONTHLY_EVENT && setMidnight(data.close_date).getTime() < (0,time/* getKoreaDate */.jw)().getTime()) {
            e.preventDefault();
            return;
        }
        if (CLOSE_TIEM_DEAL) {
            e.preventDefault();
            return;
        }
        if (!userInfo.id) {
            window.location.href = "".concat("https://www.classu.co.kr", "/class/classDetail/").concat(data.class_id);
            return;
        }
        goToClassDetail(data.class_id);
    };
    var onMouseDownCard = function(e) {
        if (!IS_MONTHLY_EVENT && setMidnight(data.close_date).getTime() < (0,time/* getKoreaDate */.jw)().getTime()) {
            e.preventDefault();
            return;
        }
        // 타임딜의 경우, 해당 클래스의 close_date 값이 없어, 이벤트가 끝나는 시간 기준으로 한다.
        if (CLOSE_TIEM_DEAL) {
            e.preventDefault();
            return;
        }
        var targetURL = '';
        if (isWebview) {
            return;
        }
        if (e.buttons === 4) {
            e.stopPropagation();
            targetURL = "".concat("https://www.classu.co.kr", "/class/classDetail/").concat(data.class_id);
            window.open(targetURL, '_blank');
        }
    };
    var profileDelegator = function(e) {
        if (setMidnight(data.close_date).getTime() < (0,time/* getKoreaDate */.jw)().getTime()) {
            e.preventDefault();
            return;
        }
        // 타임딜의 경우, 해당 클래스의 close_date 값이 없어, 이벤트가 끝나는 시간 기준으로 한다.
        if (CLOSE_TIEM_DEAL) {
            e.preventDefault();
            return;
        }
        e.stopPropagation();
        goToProfile(data.coach_id);
    };
    var onMouseDownProfile = function(e) {
        if (isWebview) {
            return;
        }
        if (e.buttons === 4) {
            e.stopPropagation();
            window.open("".concat("https://www.classu.co.kr", "/new/user/").concat(data.coach_id), '_blank');
        }
    };
    var StatusCover = function() {
        // 얼리버드 이벤트에만 마감된 클래스가 존재한다.
        if (IS_EARLYBIRD_EVENT) {
            if (setMidnight(data.close_date).getTime() < (0,time/* getKoreaDate */.jw)().getTime()) {
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Close, {}));
            }
            return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}));
        }
        // 항시 오픈 이벤트 (예: 초저가 이벤트)
        if (!eventInfo.open_date || !eventInfo.close_date) {
            return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}));
        }
        // 종료된 이벤트 (예: 타입딜)
        if (CLOSE_TIEM_DEAL) {
            return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Close, {}));
        }
        // 현재 진행 중인 이벤트
        if (new Date((0,time/* iosTimeFormat */.jH)(eventInfo.open_date)) < (0,time/* getKoreaDate */.jw)() && new Date((0,time/* iosTimeFormat */.jH)(eventInfo.close_date)) > (0,time/* getKoreaDate */.jw)()) {
            return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}));
        }
        // 오픈 30분 전 체크
        var earlier = Math.floor((new Date((0,time/* iosTimeFormat */.jH)(eventInfo.open_date)).getTime() - (0,time/* getKoreaDate */.jw)().getTime()) / 1000 / 60) > 0 && Math.floor((new Date((0,time/* iosTimeFormat */.jH)(eventInfo.open_date)).getTime() - (0,time/* getKoreaDate */.jw)().getTime()) / 1000 / 60) <= 30;
        if (earlier) {
            return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Ready, {}));
        }
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Close, {}));
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(Item, {
        IS_ROWITEM: IS_ROWITEM,
        onClick: onClickClass,
        onMouseDown: onMouseDownCard,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CoverWrapper, {
                IS_ROWITEM: IS_ROWITEM,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ClassCover/* default */.Z, {
                        src: data.class_photo
                    }),
                    IS_EARLYBIRD_EVENT && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            getDateDiff((0,time/* dateTimeFormatter */.CI)(setMidnight(data.close_date)), (0,time/* getKoreaDate */.jw)()) === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Message, {
                                children: "오늘 마감"
                            }),
                            getDateDiff((0,time/* dateTimeFormatter */.CI)(setMidnight(data.close_date)), (0,time/* getKoreaDate */.jw)()) >= 7 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Message, {
                                children: "신규 등록"
                            }),
                            getDateDiff((0,time/* dateTimeFormatter */.CI)(setMidnight(data.close_date)), (0,time/* getKoreaDate */.jw)()) > 0 && getDateDiff((0,time/* dateTimeFormatter */.CI)(setMidnight(data.close_date)), (0,time/* getKoreaDate */.jw)()) < 7 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Message, {
                                children: [
                                    (((0,time/* dateTimeFormatter */.CI)(setMidnight(data.close_date)).getTime() - (0,time/* getKoreaDate */.jw)().getTime()) / (1000 * 60 * 60 * 24)).toFixed(0),
                                    "일 남음"
                                ]
                            })
                        ]
                    }),
                    !IS_MONTHLY_EVENT && /*#__PURE__*/ (0,jsx_runtime.jsx)(StatusCover, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Info, {
                IS_ROWITEM: IS_ROWITEM,
                isClose: !IS_MONTHLY_EVENT && // 타임딜의 경우, 해당 클래스의 close_date 값이 없어, 이벤트가 끝나는 시간 기준으로 한다.
                (CLOSE_TIEM_DEAL || getDateDiff((0,time/* dateTimeFormatter */.CI)(setMidnight(data.close_date)), (0,time/* getKoreaDate */.jw)()) < 0),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AvatarButton, {
                            onClick: profileDelegator,
                            onMouseDown: onMouseDownProfile,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                width: 32,
                                height: 32,
                                src: data.coach_photo
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                                children: data.class_name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Summary, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Coach, {
                                        onClick: profileDelegator,
                                        onMouseDown: onMouseDownProfile,
                                        children: data.coach_name
                                    }),
                                    data.curriculum_cnt && /*#__PURE__*/ (0,jsx_runtime.jsx)(CurriculumCount, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: "".concat(data.curriculum_cnt, "강")
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Price, {
                                children: [
                                    eventInfo.life_flag === 'Y' && /*#__PURE__*/ (0,jsx_runtime.jsx)(SalePer, {
                                        children: "평생소장"
                                    }),
                                    eventInfo.life_flag === 'N' && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: !!parseInt(data.payment_info_data1 || data.price_sale, 10) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(SalePer, {
                                            children: [
                                                Math.floor(data.payment_info_data1 || data.price_sale),
                                                "%"
                                            ]
                                        })
                                    }),
                                    (data.payment || data.payment_info_data4 || data.payment_price) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(SalePrice, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "월"
                                            }),
                                            (0,number/* formatToPrice */.t)(data.payment_info_data4 || data.payment || data.payment_price),
                                            "원"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        children: eventInfo.life_flag === 'Y' && 'X 3개월'
                                    })
                                ]
                            }),
                            !!(data.review_score || data.star_avg || data.group_signup_member_count) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Status, {
                                children: [
                                    !!data.star_avg && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Star/* default */.Z, {
                                                type: "S",
                                                isActive: true
                                            }),
                                            Math.ceil(data.star_avg * 10) / 10
                                        ]
                                    }),
                                    IS_EARLYBIRD_EVENT && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        children: [
                                            data.group_member_limit - data.group_signup_member_count % data.group_member_limit,
                                            "명 남음"
                                        ]
                                    }),
                                    !IS_EARLYBIRD_EVENT && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        children: [
                                            !!data.signup_cnt && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    "멤버 ",
                                                    (0,number/* formatToPrice */.t)(data.signup_cnt)
                                                ]
                                            }),
                                            !!data.mission_cnt && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    "\xa0\xa0활동 ",
                                                    (0,number/* formatToPrice */.t)(data.mission_cnt)
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            eventInfo.life_flag === 'N' && data.star_cnt === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(FirstOpenBadge, {
                                children: "최초 오픈 할인 이벤트"
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};
var skeleton = (0,styled_components_browser_esm/* css */.iv)(EventItem_templateObject(), styles/* palette.grey010 */.DG.grey010);
var Item = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1ea3e809-0"
})(_templateObject3(), function(param) {
    var IS_ROWITEM = param.IS_ROWITEM;
    return IS_ROWITEM ? (0,styled_components_browser_esm/* css */.iv)(_templateObject1(), styles/* palette.system.BNB */.DG.system.BNB, styles/* mediaQuery.large */.cy.large, styles/* palette.system.grey */.DG.system.grey) : (0,styled_components_browser_esm/* css */.iv)(_templateObject2());
}, styles/* palette.grey010 */.DG.grey010, styles/* mediaQuery.medium */.cy.medium);
var CoverWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1ea3e809-1"
})(_templateObject6(), function(param) {
    var IS_ROWITEM = param.IS_ROWITEM;
    return IS_ROWITEM ? (0,styled_components_browser_esm/* css */.iv)(_templateObject4()) : (0,styled_components_browser_esm/* css */.iv)(_templateObject5());
}, styles/* mediaQuery.medium */.cy.medium);
var Info = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1ea3e809-2"
})(_templateObject9(), function(param) {
    var isClose = param.isClose;
    return isClose ? 0.5 : 1;
}, function(param) {
    var IS_ROWITEM = param.IS_ROWITEM;
    return IS_ROWITEM ? (0,styled_components_browser_esm/* css */.iv)(_templateObject7()) : (0,styled_components_browser_esm/* css */.iv)(_templateObject8());
}, styles/* mediaQuery.medium */.cy.medium);
var AvatarButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-1ea3e809-3"
})(_templateObject10());
var Title = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-1ea3e809-4"
})(_templateObject11(), typography/* subtitle4_medium */.b_, styles/* palette.grey75 */.DG.grey75, skeleton, styles/* mediaQuery.large */.cy.large);
var Summary = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1ea3e809-5"
})(_templateObject12(), typography/* caption3_regular */.dK, styles/* palette.grey040 */.DG.grey040, styles/* mediaQuery.large */.cy.large, typography/* caption2_regular */.Ug);
var Coach = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-1ea3e809-6"
})(_templateObject13(), styles/* palette.grey0 */.DG.grey0, skeleton);
var CurriculumCount = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-1ea3e809-7"
})(_templateObject14());
var Price = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1ea3e809-8"
})(_templateObject15(), styles/* palette.grey040 */.DG.grey040);
var SalePer = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-1ea3e809-9"
})(_templateObject16(), typography/* subtitle3_bold */.Zl, styles/* palette.red060 */.DG.red060, styles/* mediaQuery.large */.cy.large, skeleton);
var SalePrice = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-1ea3e809-10"
})(_templateObject17(), typography/* subtitle3_bold */.Zl, styles/* palette.grey75 */.DG.grey75, skeleton, styles/* mediaQuery.large */.cy.large);
var Status = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-1ea3e809-11"
})(_templateObject18(), typography/* body3_regular */.PD, styles/* palette.grey25 */.DG.grey25, styles/* mediaQuery.large */.cy.large, styles/* palette.grey040 */.DG.grey040, skeleton);
var FirstOpenBadge = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1ea3e809-12"
})(_templateObject19(), styles/* palette.red060 */.DG.red060, styles/* palette.red060 */.DG.red060);
/* harmony default export */ var card_EventItem = (EventItem);

;// CONCATENATED MODULE: ./src/components/organisms/main/ClassGridList.js


// components


// styles

function ClassGridList_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function ClassGridList_templateObject() {
    var data = ClassGridList_taggedTemplateLiteral([
        "\n  padding: 0 16px;\n  margin-left: -16px;\n\n  ",
        " {\n    padding: 0 0;\n  }\n"
    ]);
    ClassGridList_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ClassGridList_templateObject1() {
    var data = ClassGridList_taggedTemplateLiteral([
        "\n    ",
        "\n  "
    ]);
    ClassGridList_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ClassGridList_templateObject2() {
    var data = ClassGridList_taggedTemplateLiteral([
        "\n  display: ",
        ";\n  width: 100%;\n  padding-left: 16px;\n  margin-top: 20px;\n  font-size: 0;\n  transition: width 0.2s ease;\n  vertical-align: top;\n\n  ",
        ";\n\n  ",
        " {\n    display: inline-block;\n  }\n"
    ]);
    ClassGridList_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
/**
 * 클래스 Card 그리드 형태
 * @param {object} props
 * @param {'MAIN' | 'EVENT'} props.type 카드 타입
 * @param {import('types/slices/main').RecommendClass[]| import('types/slices/main').LowPriceClass[]} 클래스 목록
 * @param {boolean} props.isLoading 로딩 여부
 * @param {boolean} props.showSalePer 할인율 노출 여부
 * @param {boolean} props.showPrice 가격 노출 여부
 * @param {object[default|small|medium|large|xlarge]} props.slidePerView 뷰포트에 보여질 슬라이드 비율
 * @param {boolean} props.showBookmark 북마크 추가/제거 기능 여부
 */ var ClassGridList = function(param) {
    var _type = param.type, type = _type === void 0 ? 'MAIN' : _type, _list = param.list, list = _list === void 0 ? [] : _list, isLoading = param.isLoading, showSalePer = param.showSalePer, showPrice = param.showPrice, slidePerView = param.slidePerView, _showBookmark = param.showBookmark, showBookmark = _showBookmark === void 0 ? false : _showBookmark;
    var skeletonArray = new Array(10).fill(0);
    var data = isLoading ? skeletonArray : list;
    var Items = data.map(function(v, i) {
        var variant = v.image_small ? 'banner' : 'class';
        return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(ClassGridList_Item, {
            slidePerView: slidePerView,
            variant: variant,
            children: [
                type === 'MAIN' && /*#__PURE__*/ (0,jsx_runtime.jsx)(ColumnItem/* default */.Z, {
                    data: v,
                    showSalePer: showSalePer,
                    showPrice: showPrice,
                    showProfile: true,
                    variant: variant,
                    showBookmark: showBookmark
                }),
                type === 'EVENT' && /*#__PURE__*/ (0,jsx_runtime.jsx)(card_EventItem, {
                    data: v
                })
            ]
        }, "".concat(v.class_id).concat(i)));
    });
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(List, {
        children: Items
    }));
};
var List = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-d12dc573-0"
})(ClassGridList_templateObject(), styles/* mediaQuery.large */.cy.large);
var createCss = function(obj) {
    var styles = '';
    for(var i = 0, len = obj.length; i < len; i++){
        if (obj[i].break === 'default') {
            styles += "\n\t\t\t\t\twidth: calc(100% / ".concat(obj[i].view, ");\n        \n          &:nth-of-type(-n + ").concat(obj[i].view, ") {\n            margin-top: 0;\n          }\n\t\t\t");
            continue;
        }
        styles += "\n\t\t\t@media (min-width: ".concat(obj[i].break, "px) {\n\t\t\t\twidth: calc(100% / ").concat(obj[i].view, ");\n\t\t\t\t&:nth-of-type(-n + ").concat(obj[i].view, ") {\n          margin-top: 0;\n        }\n\t\t\t}\n\t\t");
    }
    return (0,styled_components_browser_esm/* css */.iv)(ClassGridList_templateObject1(), styles);
};
var ClassGridList_Item = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-d12dc573-1"
})(ClassGridList_templateObject2(), function(param) {
    var variant = param.variant;
    return variant === 'banner' ? 'none' : 'inline-block';
}, function(param) {
    var slidePerView = param.slidePerView;
    return createCss(slidePerView);
}, styles/* mediaQuery.large */.cy.large);
/* harmony default export */ var main_ClassGridList = (ClassGridList);


/***/ })

}]);